import React, {
  useContext,
  useCallback,
  useMemo,
  useEffect,
  useState,
} from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TextField,
  Grid,
  InputAdornment,
  Pagination,
  Stack,
  Backdrop,
  useTheme,
  Typography,
  MenuItem,
  Divider,
  ListItemButton,
  Tooltip,
  Menu,
  MenuList,
  Checkbox,
} from "@mui/material";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import { PreferencesContext } from "../../PreferencesContext";
import MissingConsumer from "../../Components/MissingConsumer";
import {
  ExportFilesFunction,
  getCurrentFinancialYear,
  numberFormat,
  useQuery,
} from "../../shared/CommonFuctions";
import { Balance, KeyboardArrowDownSharp } from "@mui/icons-material";
import { DateRange } from "react-date-range";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import SplashComponent from "../../Navigation/splash";
import { AlertType } from "../../shared/Modal/AlertType";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { StyledMenu } from "../../Components/StyleMenus";
import { format } from "date-fns";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import { GetPurchaseSummaryByProduct } from "../../Services/PurchaseService";
import { GetLabelLevelPartyBalance, GetPurchaseSummaryByProductReport } from "../../Services/ReportService";
import {
  GetBalanceList,
  GetLabelDetail,
  GetLabelDetailed,
  GetLabelDetailedReport,
  GetLabelLevelPartyBalanceReport,
  GetLabelList,
  GetPartyTabelList,
} from "../../Services/LabelService";
import MultiSelectSim from "../../Components/MultiSelectSimple";
import { DateRangeIcon } from "@mui/x-date-pickers";
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from "material-ui-popup-state/hooks";
import MultiSelect from "../../Components/MultiSelect";
import LockIcon from "@mui/icons-material/Lock";
import CustomColumn from "../../Assets/custom-column.svg";
import DateRangePopup from "../../Components/DateRangePopup";
import { GetLedgerListByAccountCode } from "../../Services/AccountService";
import { CreateConfiguration, GetSystemConfigurationById, UpdateConfiguration } from "../../Services/SystemConfigurationService";

const parameters = {
  consumerId: 25,
  branchId: 1,
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  lessThanValue: "",
};

type Order = "asc" | "desc" | "";

interface Data {
  labelId: number;
  mappingCount: number;
  name: string;
  debitAmount: number;
  creditAmount: number;
  totalAmount: number;
  voucherNo: number;
  tableName: string;
  transactionDate: string | number | Date;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

interface EnhancedTableProps {
  order: Order;
  orderBy: String;
  rowCount: number;
  reportConfigDetail: any;
}

export default function ProjectLevelPartyBalanceReport() {
  const popupState = usePopupState({ variant: "popover", popupId: "demoMenu" });
  const theme = useTheme();
  const navigate = useNavigate();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [param, setParam] = useState(parameters);
  const [fromDate, setFromDate] = useState<any>(
    userContext.financialYearStartDate
  );
  const [toDate, setToDate] = useState<any>(userContext.financialYearEndDate);
  const [order, setOrder] = useState<Order>("");
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [resultData, setResultData] = useState([]);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const matches = useMediaQuery("(max-width:425px)");
  const mobile = useMediaQuery("(max-width:320px)");
const mobile1 = useMediaQuery("(max-width:375px)");
const mobile2 = useMediaQuery("(max-width:425px)");
const tablet = useMediaQuery("(max-width:768px)");
const tablet2 = useMediaQuery("(max-width:1024px)");
const largeScreen = useMediaQuery("(max-width:1440px)");

const tableMaxWidth = mobile
    ? "100vw"
    : mobile1
        ? "100vw"
        : mobile2
            ? "100vw"
            : tablet
                ? "calc(100vw - 40px)"
                : tablet2
                    ? "calc(100vw - 80px)"
                    : largeScreen
                        ? "calc(100vw - 140px)"
                        : "calc(100vw - 180px)";
  const edService = new EncryptDecryptService();
  const openExportType = Boolean(anchorEl2);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGE_SIZE);
  const [labelDropdown, setLabelDropdown] = React.useState([]);
  const [labelList, setLabelList] = React.useState([]);
  const [categorysSelectedOption, setCategorysSelectedOption] =
    React.useState<any>([]);

  const [productCollection, setProductCollection] = useState<any>([]);
  const [labelSelectedOption, setLabelSelectedOption] = React.useState<any>([]);
  const [selectedLabelIdData, setSelectedLabelIdData] = React.useState<any>([]);
  const [sourceLedgerColl, setSourceLedgerColl] = React.useState<any>([]);
  const [selectedLedgerAccount, setSelectedLedgerAccount] = React.useState<any>(
    []
  );
  const [partyCollection, setPartyCollection] = useState<any>([]);
  const [partyList, setPartyList] = React.useState([]);
  const [partySelectedOption, setPartySelectedOption] = React.useState<any>([]);
  const [selectedPartyIdData, setSelectedPartyIdData] = React.useState<any>([]);
  const [balanceCollection, setBalanceCollection] = useState<any>([]);
  const [balanceList, setBalanceList] = React.useState([]);
  const [balanceSelectedOption, setBalanceSelectedOption] = React.useState<any>([]);
  const [selectedBalanceIdData, setSelectedBalanceIdData] = React.useState<any>([]);
  const [selectedLedgerAccountData, setSelectedLedgerAccountData] =
    React.useState<any>("");
  const [selectedGroupCodesData, setselectedGroupCodesData] =
    React.useState<any>("");
  const [selectedIndex, setSelectedIndex] = React.useState(5);
  const [isCustomDate, setIsCustomDate] = React.useState(false);
  const [dateHeading, setDateHeading] = React.useState<any>(
    "Current financial year"
  );
  const [anchorE4, setAnchorEl4] = React.useState<HTMLButtonElement | null>(
    null
  );

  const [popupAnchor, setPopupAnchor] = useState<HTMLElement | null>(null);
  const [tempFromDate, setTempFromDate] = useState<dayjs.Dayjs | null>(null);
  const [tempToDate, setTempToDate] = useState<dayjs.Dayjs | null>(null);
  const [dateError, setDateError] = useState<string | null>(null);

  const [voucherTypeOptions, setVoucherTypeOptions] = useState([
    { label: "Receipt", value: "Receipt" },
    { label: "Contra", value: "Contra" },
    { label: "Payment", value: "Payment" },
    { label: "Journal", value: "Journal" },
    { label: "Purchase", value: "Purchase" },
    { label: "Debit Note", value: "DebitNote" },
    { label: "Sale", value: "SALE" },
    { label: "Credit Note", value: "CreditNote" },
    { label: "Sale Receipt", value: "SaleReceipt" },
  ]);
  const [selectedVoucherTypes, setSelectedVoucherTypes] = useState<string[]>(
    []
  );
  const handleVoucherTypeChange = (selectedValues: string[]) => {
    setSelectedVoucherTypes(selectedValues);
  };

  const labelTitle = userContext.consumerId === 32 ? "Project" : "Label";

  const [tableTotals, setTableTotals] = useState({
    materialPurchase: 0,
    otherExpense: 0,
    salesInvoice: 0,
    partyPaid: 0,
    netBalance: 0,
    balance: 0,
    partyReceived: 0,
  });

  const location = useLocation();
  let urlParams = useQuery();
  const encryptedLabelId = urlParams.get("q");
  let decryptLabelId: any = edService.decrypt(encryptedLabelId);
  let convertedLabelId: any = parseInt(decryptLabelId) || 0;
  const encryptedPartyId = urlParams.get("q");
  let decryptPartyId: any = edService.decrypt(encryptedPartyId);
  let convertedPartyId: any = parseInt(decryptPartyId) || 0;
  const encryptedStatusId = urlParams.get("q");
  let decryptStatusId: any = edService.decrypt(encryptedStatusId);
  let convertedStatusId: any = parseInt(decryptStatusId) || 0;

  const pageInfo = useMemo(
    () => ({
      startIndex: (page - 1) * PAGE_SIZE + 1,
      endIndex: (page - 1) * PAGE_SIZE + resultData.length,
      totalPages: Math.ceil(totalCount / PAGE_SIZE),
    }),
    [page, resultData.length, totalCount]
  );

  const handleSearch = useCallback((val: string) => {
    setSearchValue(val);
    setPage(1);
    setParam((prev) => ({ ...prev, searchValue: val, pageIndex: 1 }));
  }, []);

  const handlePageChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
      setParam((prev) => ({ ...prev, pageIndex: value }));
    },
    []
  );

  const handleChangeAccount = (object: any) => {
    setSelectedLedgerAccount(object);
    setSelectedLedgerAccountData(object?.map((x) => x.value)?.join(","));
  };

  const handleChangeCategory = (object: any) => {
    setLabelSelectedOption(object);
    let tempCustomerIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let labelId = x.labelId;
        x.labelId = labelId;
        tempCustomerIdData.push(labelId.toString());
      }
    });
    setSelectedLabelIdData(tempCustomerIdData);
  };

  const handleChangeParty = (object: any) => {
    setPartySelectedOption(object);
    let tempPartyIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let partyId = x.partyId ?? x.value;
        x.partyId = partyId;
        tempPartyIdData.push(partyId.toString());
      }
    });
    setSelectedPartyIdData(tempPartyIdData);
  };

  const handleChangeBalance = (object: any) => {
    setBalanceSelectedOption(object);
    let tempBalanceIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let statusId = x.statusId ?? x.value;
        x.statusId = statusId;
        tempBalanceIdData.push(statusId.toString());
      }
    });
    setSelectedBalanceIdData(tempBalanceIdData);
  };

  const startDate = new Date(userContext.financialYearStartDate);
  const endDate = new Date(userContext.financialYearEndDate);
  const [selectedDateRange, setDateRange] = useState<any>([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    setSelectedIndex(index);
    switch (index) {
      case 0:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Today");
        break;
      case 1:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                1 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                1 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
            key: "selection",
          },
        ]);
        setDateHeading("Yestarday");
        break;
      case 2:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                14 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 14 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Last 15 days");
        break;
      case 3:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                29 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 29 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Last 30 days");
        break;
      case 4:
        setDateRange([
          {
            startDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate).getTime() -
                89 * 24 * 60 * 60 * 1000
                : new Date().getTime() - 89 * 24 * 60 * 60 * 1000,
            endDate:
              userContext.financialYear !== getCurrentFinancialYear()
                ? new Date(userContext.financialYearEndDate)
                : new Date(),
            key: "selection",
          },
        ]);
        setDateHeading("Last 90 days");
        break;
      case 5:
        setDateRange([
          {
            startDate: new Date(userContext.financialYearStartDate),
            endDate: new Date(userContext.financialYearEndDate),
            key: "selection",
          },
        ]);
        setDateHeading("Current financial year");
        break;
      case 6:
        // setDateHeading(`${formatDate(new Date(selectedDateRange[0].startDate))} To ${formatDate(new Date(selectedDateRange[0].endDate))}`)
        setIsCustomDate(true);
        break;
      case 7:
        setDateRange([
          {
            startDate: new Date("1900-01-01"),
            endDate: new Date("2100-12-31"),
            key: "selection",
          },
        ]);
        setDateHeading("All");
        break;
      default:
        break;
    }
  };

  const handleDateRange = (selected: any, popupState) => {
    // Your logic here
    const calenderHeading =
      format(new Date(selected[0].startDate), "dd-MM-yyyy") +
      " To " +
      format(new Date(selected[0].endDate), "dd-MM-yyyy");
    setDateRange(selected);
    setDateHeading(calenderHeading);
    popupState.close();
  };

  const handleMoveToDetail = useCallback(
    async (productId: number) => {
      try {
        const encProductId = edService.encrypt(productId.toString());
        navigate({
          pathname: "/purchase-details-by-product",
          search: `?q=${encodeURIComponent(encProductId || "")}`,
        });
      } catch (e: any) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: typeof e === "string" ? e : e?.message,
          alertType: AlertType.Error,
        });
      }
    },
    [navigate, edService, userContext, updateUserContext]
  );

  async function fetchLedgerAccountListByCode(codes: any) {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("accountCodes", codes);
      const ledgerData: any = await GetLedgerListByAccountCode(params);
      if (ledgerData?.data?.data) {
        let ledgerList = ledgerData.data.data;
        setSourceLedgerColl(ledgerList);
      }
    } catch (e: any) {
      // setSubmitting(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function fetchLabelLevelPartyBalance() {

    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    if (
      convertedLabelId > 0 &&
      selectedLabelIdData?.length === 0 &&
      labelSelectedOption?.length === 0
    ) {
      params.append("labelId", convertedLabelId.toString());
    } else {
      params.append("labelId", selectedLabelIdData);
    }
    params.append("pageIndex", page.toString());
    params.append("pageSize", PAGE_SIZE.toString());
    params.append("searchValue", searchValue);
    // params.append("financialYear", userContext.financialYear.toString());
    if (selectedLedgerAccountData !== null) {
      params.append("accountIds", selectedLedgerAccountData);
    }
    if (selectedPartyIdData?.length > 0) {
      params.append("partyType", selectedPartyIdData);
    }
    if (selectedBalanceIdData?.length > 0) {
      params.append("status", selectedBalanceIdData);
    }
    params.append(
      "startDate",
      format(new Date(selectedDateRange[0].startDate), "yyyy-MM-dd")
    );
    params.append(
      "endDate",
      format(new Date(selectedDateRange[0].endDate), "yyyy-MM-dd")
    );
    params.append("mode", "List");
    try {
      setLoading(true);
      const result: any = await GetLabelLevelPartyBalanceReport(params);
      if (
        result &&
        result.data.data &&
        result.data.data.labelLevelPartyBalanceCollection
      ) {
        let labelInfo = result.data.data.labelLevelPartyBalanceCollection;
        let dataCount = result.data.data.totalCount;
        setResultData(labelInfo);
        setTableTotals({
          materialPurchase: result.data.data?.totalMaterialPurchase || 0,
          otherExpense: result.data.data?.totalOtherExpense || 0,
          salesInvoice: result.data.data?.totalSalesInvoice || 0,
          partyPaid: result.data.data?.totalPartyPaid || 0,
          partyReceived: result.data.data?.totalPartyReceived || 0,
          netBalance: result.data.data?.totalNetBalance || 0,
          balance: result.data.data?.totalBalance || 0,
        });
        setTotalCount(dataCount);
        setLoading(false);
      } else {
        console.log("Error");
        setLoading(false);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
    setLoading(false);
  }

  const fetchLabelList = async () => {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("userId", userContext.userId.toString());
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "");

      const result: any = await GetLabelList(params);
      if (result && result.data && result.data.data) {
        let labelInfo = result.data.data?.labelCollection;
        setLabelList(labelInfo);
        setProductCollection(labelInfo);
        return labelInfo;
      } else {
        console.log("Error");
        setLoading(false);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const fetchPartyList = async () => {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("userId", userContext.userId.toString());
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "");

      const result: any = await GetPartyTabelList(params);
      if (result && result.data && result.data.data) {
        const defaultPartyOptions = [
          { label: "Supplier", value: "Supplier", partyId: "Supplier" },
          { label: "Buyer", value: "Buyer", partyId: "Buyer" },
          {
            label: "Expense",
            value: "Expense",
            partyId: "Expense",
          },
          {
            label: "Income",
            value: "Income",
            partyId: "Income",
          },
        ];
        const partyInfoRaw = result.data.data?.partyLabelCollection || [];
        const partyInfo = (partyInfoRaw || []).map((item: any) => {
          const value = item?.value ?? item?.Value ?? item?.name ?? item?.Name;
          const label = item?.label ?? item?.Label ?? item?.name ?? item?.Name;
          return {
            ...item,
            value,
            label,
            partyId: value,
          };
        }).filter((item: any) => item?.label && item?.value);

        const finalPartyInfo =
          partyInfo?.length > 0 ? partyInfo : defaultPartyOptions;
        setPartyList(finalPartyInfo);
        setPartyCollection(finalPartyInfo);
        return finalPartyInfo;
      } else {
        console.log("Error");
        setLoading(false);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const fetchBalanceList = async () => {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("userId", userContext.userId.toString());
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "");

      const result: any = await GetBalanceList(params);
      if (result && result.data && result.data.data) {
        const defaultBalanceOptions = [
          { label: "Settled", value: "Settled", statusId: "Settled" },
          {
            label: "Advance Paid",
            value: "Advance Paid",
            statusId: "Advance Paid",
          },
          { label: "Payable", value: "Payable", statusId: "Payable" },
          {
            label: "Advance Received",
            value: "Advance Received",
            statusId: "Advance Received",
          },
          {
            label: "Receivable",
            value: "Receivable",
            statusId: "Receivable",
          },
          {
            label: "Expense",
            value: "Expense",
            statusId: "Expense",
          },
          {
            label: "Income",
            value: "Income",
            statusId: "Income",
          },
        ];
        const balanceInfoRaw = result.data.data?.balanceTypeCollection || [];
        const balanceInfo = (balanceInfoRaw || [])
          .map((item: any) => {
            const value =
              item?.value ??
              item?.Value ??
              item?.statusId ??
              item?.StatusId ??
              item?.labelId ??
              item?.LabelId;
            const label =
              item?.label ??
              item?.Label ??
              item?.name ??
              item?.Name ??
              item?.balanceType;

            return {
              ...item,
              value,
              label,
              statusId: item?.statusId ?? item?.StatusId ?? value,
            };
          })
          .filter((item: any) => item?.label && item?.value);

        const finalBalanceInfo =
          balanceInfo?.length > 0 ? balanceInfo : defaultBalanceOptions;
        setBalanceList(finalBalanceInfo);
        setBalanceCollection(finalBalanceInfo);
        return finalBalanceInfo;
      } else {
        console.log("Error");
        setLoading(false);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  async function handelLabelLevelBalanceReportPopup(type: any) {
    setAnchorEl2(null);
    setLoading(true);
    let params = new URLSearchParams();
    var attachmentName = "";
    if (type === "pdf") {
      attachmentName = "LabelLevelPartyBalanceReport.pdf";
    } else {
      attachmentName = "LabelLevelPartyBalanceReport.xls";
    }
    params.append("reportName", "LabelLevelPartyBalanceReport");
    params.append("reportType", type);
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    if (
      convertedLabelId > 0 &&
      selectedLabelIdData?.length === 0 &&
      labelSelectedOption?.length === 0
    ) {
      params.append("labelId", convertedLabelId.toString());
    } else {
      params.append("labelId", selectedLabelIdData);
    }
    // params.append("financialYear", userContext.financialYear.toString());
    if (selectedLedgerAccountData !== null) {
      params.append("accountIds", selectedLedgerAccountData);
    }
    params.append("pageIndex", page.toString());
    params.append("pageSize", PAGE_SIZE.toString());
    params.append("isMaterialPurchaseEnable", reportConfig["MATERIAL_PURCHASE"] ? "true" : "false");
    params.append("isOtherExpenseEnable", reportConfig["OTHER_EXPENSE"] ? "true" : "false");
    params.append("isSubconExpenseEnable", reportConfig["SUBCON_EXPENSE"] ? "true" : "false");
    params.append("isSiteExpenseEnable", reportConfig["SITE_EXPENSE"] ? "true" : "false");
    params.append("isEquipmentExpenseEnable", reportConfig["EQUIPMENT_EXPENSE"] ? "true" : "false");
    params.append("isDebitNoteEnable", reportConfig["DEBIT_NOTE"] ? "true" : "false");
    params.append("isSalesInvoiceEnable", reportConfig["SALES_INVOICE"] ? "true" : "false");
    params.append("isCreditNoteEnable", reportConfig["CREDIT_NOTE"] ? "true" : "false");
    params.append("isMaterialSaleEnable", reportConfig["MATERIAL_SALE"] ? "true" : "false");
    params.append("isPartyReceivedEnable", reportConfig["PARTY_RECEIVED"] ? "true" : "false");
    params.append("isPartyPaidEnable", reportConfig["PARTY_PAID"] ? "true" : "false");
    params.append("isTotalPayableEnable", reportConfig["TOTAL_PAYABLE"] ? "true" : "false");
    params.append("isDuePayableEnable", reportConfig["DUE_PAYABLE"] ? "true" : "false");
    params.append("isTotalReceivableEnable", reportConfig["TOTAL_RECEIVABLE"] ? "true" : "false");
    params.append("isDueReceivableEnable", reportConfig["DUE_RECEIVABLE"] ? "true" : "false");
    params.append("isHandsOnEnable", reportConfig["HANDS_ON_BALANCE"] ? "true" : "false");
    params.append("isNetBalanceEnable", reportConfig["NET_BALANCE"] ? "true" : "false");
    params.append("searchValue", searchValue);
    if (selectedPartyIdData?.length > 0) {
      params.append("partyType", selectedPartyIdData);
    }
    if (selectedBalanceIdData?.length > 0) {
      params.append("status", selectedBalanceIdData);
    }
    params.append(
      "startDate",
      format(new Date(selectedDateRange[0].startDate), "yyyy-MM-dd")
    );
    params.append(
      "endDate",
      format(new Date(selectedDateRange[0].endDate), "yyyy-MM-dd")
    );
    params.append("mode", "EXPORT");
    try {
      const result: any = await GetLabelLevelPartyBalance(params);

      if (result && result.data && result.data.data) {
        var fileContent = result?.data?.data?.fileData;
        var attachmentData = fileContent;
        ExportFilesFunction(attachmentName, type, attachmentData);
        setLoading(false);
      }
      setLoading(false);
    } catch (e: any) {
      // setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
      setLoading(false);
    }
  }

  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };

  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const configurationSetting = React.useMemo(() => {
    return userContext?.systemConfigurationColl?.find(
      (item) =>
        item?.configModule === "LABEL_LEVEL_REPORT" &&
        item?.configKey === "SHOW_FIELDS"
    );
  }, [userContext?.systemConfigurationColl]);

  const reportConfigList = React.useMemo(() => {
    return (
      userContext?.systemConfigurationDetailColl?.filter(
        (item) =>
          item?.parentConfigurationModule === "LABEL_LEVEL_REPORT" &&
          item?.configModule === "SHOW_FIELDS"
      ) || []
    );
  }, [userContext?.systemConfigurationDetailColl, configurationSetting]);

  const [reportConfigDetail, setReportConfigDetail] = React.useState<any>(
    reportConfigList?.map((item) => {
      return { ...item, isChecked: item?.configValue === "1" };
    })
  );

  const reportConfig = React.useMemo(() => {
    return reportConfigDetail?.reduce((acc, item) => {
      acc[item.configKey] = item.isChecked;
      return acc;
    }, {});
  }, [reportConfigDetail]);

  const getSystemConfigurationById = async (configurationId: string) => {
    let params = new URLSearchParams();
    let configurationDetail: any = null;
    params.append("systemConfigurationId", configurationId?.toString() ?? "0");
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    try {
      const result: any = await GetSystemConfigurationById(params);
      if (result?.data?.data) {
        configurationDetail = result.data.data;
      }
      return configurationDetail;
    } catch (e: any) {
      updateUserContext({

        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };


  const handleSettingsSave = async (configData) => {
    try {
      if ((configurationSetting?.masterSystemConfigurationId ?? 0) > 0) {
        const reportConfigDetailColl = configData?.map((config) => {
          if (config?.systemConfigurationDetailId > 0) {
            config.mode = "U";
          } else {
            config.mode = "I";
          }
          config.configValue = config.isChecked ? "1" : "0";
          return config;
        });

        let result: any = "";
        let formData = {
          systemConfigurationId:
            configurationSetting?.systemConfigurationId || 0,
          masterSystemConfigurationId:
            configurationSetting?.masterSystemConfigurationId || 0,
          consumerId: userContext?.consumerId,
          firmId: userContext?.firmId || 0,
          branchId: 0, // CAUSE OF MULTI BRANCH,
          userId: 0, // CAUSE OF MULTI UASER,
          isDeleted: configurationSetting?.isDeleted || false,
          dataManagedBy: userContext?.userId || 0,
          configModule: configurationSetting?.configModule || "",
          configValue: configurationSetting?.configValue || "",
          configKeyLabel: configurationSetting?.configKeyLabel || "",
          configKey: configurationSetting?.configKey || "",
          configDataType: configurationSetting?.configDataType || "",
          systemConfigurationDetailJson: JSON.stringify(
            reportConfigDetailColl || []
          ),
        };

        if ((configurationSetting?.systemConfigurationId ?? 0) > 0) {
          result = await UpdateConfiguration(formData);
        } else {
          result = await CreateConfiguration(formData);
        }

        if (result?.data) {
          const updatedConfig = await getSystemConfigurationById(
            result?.data?.systemConfigurationId || 0
          );
          setReportConfigDetail(configData);

          let systemConfigurationColl =
            userContext?.systemConfigurationColl?.map((item) => {
              if (
                item?.configModule === updatedConfig?.configModule &&
                item.configKey === updatedConfig?.configKey
              ) {
                return {
                  ...item,
                  systemConfigurationId: updatedConfig.systemConfigurationId,
                  configValue: updatedConfig.configValue,
                };
              }
              return item;
            });

          let systemConfigurationDetailColl =
            userContext?.systemConfigurationDetailColl?.map((detailItem) => {
              const match = updatedConfig?.systemConfigurationDetailColl?.find(
                (item) =>
                  item?.parentConfigurationModule ===
                  detailItem?.parentConfigurationModule &&
                  item?.configModule === detailItem?.configModule &&
                  item?.configKey === detailItem?.configKey
              );
              if (match) {
                return {
                  ...detailItem,
                  systemConfigurationId: match.systemConfigurationId,
                  systemConfigurationDetailId:
                    match.systemConfigurationDetailId,
                  masterSystemConfigurationId:
                    match.masterSystemConfigurationId,
                  configValue: match.configValue,
                };
              }
              return detailItem;
            });

          updateUserContext({
            ...userContext,
            isAlert: true,
            alertMessage: result?.message,
            alertType: AlertType.Success,
            systemConfigurationColl: systemConfigurationColl,
            systemConfigurationDetailColl: systemConfigurationDetailColl,
          });
        }
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something went wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  const EXPENSE_GROUP = ["MATERIAL_PURCHASE", "OTHER_EXPENSE", "SUBCON_EXPENSE", "SITE_EXPENSE", "EQUIPMENT_EXPENSE", "CREDIT_NOTE"];
  const INCOME_GROUP = ["SALES_INVOICE", "MATERIAL_SALE", "DEBIT_NOTE"];
  const PAYMENT_OUT_GROUP = ["TOTAL_PAYABLE", "PARTY_PAID", "DUE_PAYABLE"];
  const PAYMENT_IN_GROUP = ["TOTAL_RECEIVABLE", "PARTY_RECEIVED", "DUE_RECEIVABLE"];

  const getLastVisibleKey = (group, config) => {
    for (let i = group.length - 1; i >= 0; i--) {
      if (config?.[group[i]]) return group[i];
    }
    return null;
  };

  const expenseLastKey = useMemo(() => getLastVisibleKey(EXPENSE_GROUP, reportConfig), [reportConfig]);
  const incomeLastKey = useMemo(() => getLastVisibleKey(INCOME_GROUP, reportConfig), [reportConfig]);
  const paymentOutLastKey = useMemo(() => getLastVisibleKey(PAYMENT_OUT_GROUP, reportConfig), [reportConfig]);
  const paymentInLastKey = useMemo(() => getLastVisibleKey(PAYMENT_IN_GROUP, reportConfig), [reportConfig]);
  const hasHandsOnBalance = !!reportConfig?.["HANDS_ON_BALANCE"];

  const [reportConfigData, setReportConfigData] = React.useState(
    reportConfigDetail
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleSettingsOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation(); // prevent bubbling issues
    setAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setReportConfigData(reportConfigDetail);
  }, [reportConfigDetail]);


  function EnhancedTableHead(props: EnhancedTableProps) {
    return (
      // checkBox for Header
      <TableHead>
        {/* ===== NAYI GROUPING ROW (EXPENSE / INCOME) ===== */}
        <TableRow>
          {/* Party Name, Party Type, Project Name - khaali rakho */}
          <TableCell colSpan={3} sx={{ borderBottom: "none" }} />

          {/* EXPENSE group header */}
          {(() => {
            const expenseCols = [
              reportConfig?.["MATERIAL_PURCHASE"],
              reportConfig?.["OTHER_EXPENSE"],
              reportConfig?.["SUBCON_EXPENSE"],
              reportConfig?.["SITE_EXPENSE"],
              reportConfig?.["EQUIPMENT_EXPENSE"],
              reportConfig?.["CREDIT_NOTE"],
            ].filter(Boolean).length;

            return expenseCols > 0 ? (
              <TableCell
                align="center"
                colSpan={expenseCols}
                sx={{
                  fontWeight: "bold",
                  borderLeft: "1px solid #ccc",
                  borderRight: "1px solid #ccc",
                }}
              >
                EXPENSE
              </TableCell>
            ) : null;
          })()}

          {/* INCOME group header */}
          {(() => {
            const incomeCols = [
              reportConfig?.["SALES_INVOICE"],
              reportConfig?.["MATERIAL_SALE"],
              reportConfig?.["DEBIT_NOTE"],
            ].filter(Boolean).length;

            return incomeCols > 0 ? (
              <TableCell
                align="center"
                colSpan={incomeCols}
                sx={{
                  fontWeight: "bold",
                  borderLeft: "1px solid #ccc",
                  borderRight: "1px solid #ccc",
                }}
              >
                INCOME
              </TableCell>
            ) : null;
          })()}

          {/* PAYMENT OUT group header */}
          {(() => {
            const paymentOutCols =
              [
                reportConfig["TOTAL_PAYABLE"],
                reportConfig?.["PARTY_PAID"],
                reportConfig?.["DUE_PAYABLE"],
              ].filter(Boolean).length;

            return paymentOutCols > 0 ? (
              <TableCell
                align="center"
                colSpan={paymentOutCols}
                sx={{
                  fontWeight: "bold",
                  borderLeft: "1px solid #ccc",
                  borderRight: "1px solid #ccc",
                }}
              >
                PAYMENT OUT
              </TableCell>
            ) : null;
          })()}

          {/* PAYMENT IN group header */}
          {(() => {
            const paymentInCols =
              [
                reportConfig["TOTAL_RECEIVABLE"],
                reportConfig?.["PARTY_RECEIVED"],
                reportConfig?.["DUE_RECEIVABLE"],
              ].filter(Boolean).length;

            return paymentInCols > 0 ? (
              <TableCell
                align="center"
                colSpan={paymentInCols}
                sx={{
                  fontWeight: "bold",
                  borderLeft: "1px solid #ccc",
                  borderRight: "1px solid #ccc",
                }}
              >
                PAYMENT IN
              </TableCell>
            ) : null;
          })()}

          {/* BALANCE group header */}
          {(() => {
            const balanceCols =
              (reportConfig?.["NET_BALANCE"] ? 1 : 0) +
              1 +
              (reportConfig?.["HANDS_ON_BALANCE"] ? 1 : 0);

            return (
              <TableCell
                align="center"
                colSpan={balanceCols}
                sx={{
                  fontWeight: "bold",
                  borderLeft: "1px solid #ccc",
                  // borderRight: "1px solid #ccc",
                }}
              >
                BALANCE
              </TableCell>
            );
          })()}

          {/* Settings icon column - khaali rakho */}
          <TableCell sx={{ borderBottom: "none" }} />
        </TableRow>

        {/* ===== AAPKI EXISTING HEADER ROW (as it is) ===== */}
        <TableRow>
          <TableCell
            sx={{
              display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="left">
            {`Party Name`}
          </TableCell>
          <TableCell
            sx={{
              display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="left">
            {"Party Type"}
          </TableCell>
          <TableCell
            sx={{
              display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
              fontWeight: "bold",
              minWidth: "80px",
              borderRight: "1px solid #ccc",
            }}
            align="left">
            {`${labelTitle} Name`}  
          </TableCell>

          {/* ===== EXPENSE GROUP - dynamic borderRight ===== */}
          {reportConfig["MATERIAL_PURCHASE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: expenseLastKey === "MATERIAL_PURCHASE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Material Purchase"}
            </TableCell>
          )}
          {reportConfig["OTHER_EXPENSE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: expenseLastKey === "OTHER_EXPENSE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Other Expense"}
            </TableCell>
          )}
          {reportConfig["SUBCON_EXPENSE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: expenseLastKey === "SUBCON_EXPENSE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Subcon Amount"}
            </TableCell>
          )}
          {reportConfig["SITE_EXPENSE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: expenseLastKey === "SITE_EXPENSE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Site Expense"}
            </TableCell>
          )}
          {reportConfig["EQUIPMENT_EXPENSE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: expenseLastKey === "EQUIPMENT_EXPENSE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Equipment Expense"}
            </TableCell>
          )}
          {reportConfig["CREDIT_NOTE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: expenseLastKey === "CREDIT_NOTE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Credit Note"}
            </TableCell>
          )}

          {/* ===== INCOME GROUP - dynamic borderRight ===== */}
          {reportConfig["SALES_INVOICE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: incomeLastKey === "SALES_INVOICE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Sales Invoice"}
            </TableCell>
          )}
          {reportConfig["MATERIAL_SALE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: incomeLastKey === "MATERIAL_SALE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Material Sale"}
            </TableCell>
          )}
          {reportConfig["DEBIT_NOTE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: incomeLastKey === "DEBIT_NOTE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Debit Note"}
            </TableCell>
          )}

          {/* ===== PAYMENT OUT GROUP - dynamic borderRight ===== */}
          {reportConfig["TOTAL_PAYABLE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: paymentOutLastKey === "TOTAL_PAYABLE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Total Payable"}
            </TableCell>
          )}
          {reportConfig["PARTY_PAID"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: paymentOutLastKey === "PARTY_PAID" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Party Paid"}
            </TableCell>
          )}
          {reportConfig["DUE_PAYABLE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: paymentOutLastKey === "DUE_PAYABLE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Due Payable"}
            </TableCell>
          )}

          {/* ===== PAYMENT IN GROUP - dynamic borderRight ===== */}
          {reportConfig["TOTAL_RECEIVABLE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: paymentInLastKey === "TOTAL_RECEIVABLE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Total Receivable"}
            </TableCell>
          )}
          {reportConfig["PARTY_RECEIVED"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: paymentInLastKey === "PARTY_RECEIVED" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Party Received"}
            </TableCell>
          )}
          {reportConfig["DUE_RECEIVABLE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                borderRight: paymentInLastKey === "DUE_RECEIVABLE" ? "1px solid #ccc" : "none",
              }}
              align="right">
              {"Due Receivable"}
            </TableCell>
          )}

          {/* ===== BALANCE GROUP ===== */}
          {reportConfig["NET_BALANCE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="left">
              {"Line Balance"}
            </TableCell>
          )}
          <TableCell
            sx={{
              display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="left">
            {"Balance Type"}
          </TableCell>
          {reportConfig["HANDS_ON_BALANCE"] && (
            <TableCell
              sx={{
                display: { xs: "table-cell", sm: "table-cell", md: "table-cell", lg: "table-cell" },
                fontWeight: "bold",
                minWidth: "80px",
                // borderRight: "1px solid #ccc",
              }}
              align="right">
              {"Hand On Balance"}
            </TableCell>
          )}
          {/* <TableCell align="right">
            <Tooltip title="Customize Columns" placement="top">
              <IconButton
                aria-label="Settings"
                onClick={handleSettingsOpen}
                sx={{ p: 0 }} disableRipple
              >
                <img src={CustomColumn} alt="Settings" height={20} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              MenuListProps={{ disablePadding: true }}
              onClose={handleSettingsClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuList sx={{ padding: 0 }}>
                <Box
                  sx={{
                    border: "1px solid #c7c5c5",
                    borderRadius: "4px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#dee6fa",
                      color: "#404d54",
                      padding: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Settings
                  </Box>
                  <Box
                    sx={{
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  >
                    {reportConfigData?.map(
                      (item, index) => (
                        <MenuItem
                          key={index}
                          sx={{
                            alignItems: "start",
                            paddingLeft: "5px",
                          }}
                          onClick={(e) => {
                            if (item?.isLocked) return;
                            setReportConfigData((prev) =>
                              prev.map((x) =>
                                x.configKey ===
                                  item?.configKey
                                  ? {
                                    ...x,
                                    isChecked:
                                      !item?.isChecked,
                                  }
                                  : x
                              )
                            );
                          }}
                        >
                          {item?.isLocked ? (
                            <LockIcon />
                          ) : (
                            <Checkbox
                              checked={item?.isChecked}
                              sx={{
                                padding: 0,
                                margin: 0,
                              }}
                            />
                          )}

                          <Typography
                            sx={{
                              fontSize: "13px !important",
                              fontWeight: "normal",
                              paddingLeft: "8px",
                            }}
                          >
                            {item?.configKeyLabel}
                          </Typography>
                        </MenuItem>
                      )
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      borderTop: "1px solid #ccc",
                      px: 2,
                      py: 1,
                      gap: "5px",
                    }}
                  >
                    <Button
                      size="small"
                      onClick={() => {
                        handleSettingsSave(reportConfigData);
                        setAnchorEl(null);
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Save
                    </Button>
                    <Button
                      onClick={handleSettingsClose}
                      size="small"
                    >
                      Close
                    </Button>
                  </Box>
                </Box>
              </MenuList>
            </Menu>
          </TableCell> */}
        </TableRow>
      </TableHead>
    );
  }

  useEffect(() => {
    const labelIds = async () => {
      const labelData = await fetchLabelList();
      if (convertedLabelId > 0 && convertedLabelId) {
        const filteroption: any = labelData?.filter((x) => {
          return x.labelId === convertedLabelId;
        });

        setLabelSelectedOption(filteroption);
        setSelectedLabelIdData([convertedLabelId.toString()]);
        handleChangeCategory(filteroption);
      }
    };
    labelIds();
  }, []);

  useEffect(() => {
    const partyIds = async () => {
      const partyData = await fetchPartyList();
      if (convertedPartyId > 0 && convertedPartyId) {
        const filteroption: any = partyData?.filter((x) => {
          const optionId = x.partyId ?? x.value ?? x.labelId;
          return optionId?.toString() === convertedPartyId?.toString();
        });

        setPartySelectedOption(filteroption);
        setSelectedPartyIdData([convertedPartyId.toString()]);
        handleChangeParty(filteroption);
      }
    };
    partyIds();
  }, []);

  useEffect(() => {
    const statusIds = async () => {
      const statusData = await fetchBalanceList();
      if (convertedStatusId > 0 && convertedStatusId) {
        const filteroption: any = statusData?.filter((x) => {
          const optionId = x.statusId ?? x.value ?? x.labelId;
          return optionId?.toString() === convertedStatusId?.toString();
        });

        setBalanceSelectedOption(filteroption);
        setSelectedBalanceIdData([convertedStatusId.toString()]);
        handleChangeBalance(filteroption);
      }
    };
    statusIds();
  }, []);

  useEffect(() => {
    fetchLedgerAccountListByCode(selectedGroupCodesData);
  }, [selectedGroupCodesData]);

  useEffect(() => {
    setIsCustomDate(false);
    setAnchorEl4(null);
    fetchLabelLevelPartyBalance();
  }, [
    page,
    param,
    selectedLedgerAccountData,
    selectedLabelIdData,
    selectedPartyIdData,
    selectedBalanceIdData,
    selectedDateRange,
    fromDate,
    toDate,
  ]);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}>
        <SplashComponent />
      </Backdrop>
      <Title pageTitle={`${labelTitle} Level Party Balance Report`} />

      {userContext.consumerId > 0 ? (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          <Grid item>
            <Grid
              item
              xs={12}
              sm={12}
              lg={6}
              md={6}
              xl={6}
              className="title-button-responsive"
              sx={{
                display: "flex !important",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4 className="page-title">{`${labelTitle} Level Party Balance Report`}</h4>
              {matches && (
                <Box sx={{ marginLeft: 'auto' }}>
                  <Button
                    variant="outlined"
                    onClick={() => navigate(-1)}
                    size="medium"
                  >
                    <ShortcutButton label="ESC" />
                    Back
                  </Button>
                </Box>
              )}
              {!matches && (
                <>
                  <Grid
                    item
                    xs={6}
                    md={3}
                    marginRight={0}
                    textAlign="end"
                    paddingTop="0px">
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "flex-end",
                        flexWrap: "wrap",
                        "& > div": {
                          minWidth: 140,
                        },
                      }}>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Material Purchase (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.materialPurchase)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Other Expense (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.otherExpense)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Sales Invoice (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.salesInvoice)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Party Paid (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.partyPaid)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Party Received (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.partyReceived)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Line Balance (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.netBalance)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Hands On Balance (₹)</Typography>
                        <Box sx={{
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          px: 1.5,
                          py: 0.5,
                          fontWeight: 600,
                          textAlign: "center",
                        }}>
                          ₹{numberFormat(tableTotals?.balance)}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", justifyContent: "flex-end", mr: "16px", ml: "auto" }}>
                        <Button
                          // color="primary"
                          variant="outlined"
                          onClick={() => navigate(-1)}
                          size="medium"
                        >
                          <ShortcutButton label="ESC" />
                          Back
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
            {matches && (
              <>
                <Grid item xs={12} md={3}>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Material Purchase (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.materialPurchase)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Other Expense (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.otherExpense)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Sales Invoice (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.salesInvoice)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Party Paid (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.partyPaid)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Party Received (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.partyReceived)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Line Balance (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.netBalance)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Hands On Balance (₹)</Typography>
                      <Box sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        px: 1.5,
                        py: 0.5,
                        fontWeight: 600,
                        textAlign: "center",
                      }}>
                        ₹{numberFormat(tableTotals?.balance)}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
          <Grid className="paper top-space">
            <Paper elevation={4} className="paper-container">
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
                className="search-space">
                <Grid item>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <TextField
                        onKeyPress={(e) => {
                          if (e.key === "Enter") handleSearch(searchValue);
                        }}
                        sx={{ paddingLeft: "0px !important", width: "100%" }}
                        className="button-responsive-stock"
                        placeholder="Search..."
                        type="text"
                        variant="outlined"
                        size="small"
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => handleSearch(searchValue)}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: searchValue && (
                            <IconButton onClick={() => handleSearch("")}>
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <MultiSelect
                        key="labelId"
                        placeholderLabel={`${labelTitle}`}
                        options={productCollection}
                        onChange={handleChangeCategory}
                        value={labelSelectedOption}
                        isSelectAll={true}
                        menuPlacement="bottom"
                      />
                    </Grid>
                    <Grid item>
                      <MultiSelect
                        placeholderLabel="Party Account"
                        options={sourceLedgerColl}
                        onChange={handleChangeAccount}
                        value={selectedLedgerAccount}
                        isSelectAll={true}
                      />
                    </Grid>
                    <Grid item>
                      <MultiSelect
                        key="partyId"
                        placeholderLabel="Party Type"
                        options={partyCollection}
                        onChange={handleChangeParty}
                        value={partySelectedOption}
                        isSelectAll={true}
                        menuPlacement="bottom"
                      />
                    </Grid>
                    <Grid item>
                      <MultiSelect
                        key="balanceId"
                        placeholderLabel="Balance Type"
                        options={balanceCollection}
                        onChange={handleChangeBalance}
                        value={balanceSelectedOption}
                        isSelectAll={true}
                        menuPlacement="bottom"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Button
                        className="button-responsive"
                        variant="outlined"
                        endIcon={<DateRangeIcon />}
                        {...bindTrigger(popupState)}
                        onClick={(e) => {
                          popupState.open(e); // open menu
                          setPopupAnchor(e.currentTarget); // for popup later
                        }}>
                        {dateHeading.toString()}
                      </Button>

                      <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                          "aria-labelledby": "demo-customized-button",
                        }}
                        {...bindMenu(popupState)}>
                        {!isCustomDate && (
                          <>
                            <Grid className="dashboard-date-label">
                              <Typography className="typography-first-child">
                                {dateHeading.toString()}
                              </Typography>
                            </Grid>
                            <Divider sx={{ margin: "0px !important" }} />
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 0}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 0)
                                }>
                                <span>Today</span>
                              </ListItemButton>
                            </MenuItem>
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 1}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 1)
                                }>
                                <span>Yestarday</span>
                              </ListItemButton>
                            </MenuItem>
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 2}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 2)
                                }>
                                <span>Last 15 days</span>
                              </ListItemButton>
                            </MenuItem>
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 3}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 3)
                                }>
                                <span>Last 30 days</span>
                              </ListItemButton>
                            </MenuItem>
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 4}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 4)
                                }>
                                <span>Last 90 days</span>
                              </ListItemButton>
                            </MenuItem>
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 5}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 5)
                                }>
                                <span>Current financial year</span>
                              </ListItemButton>
                            </MenuItem>
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={popupState.close}>
                              <ListItemButton
                                selected={selectedIndex === 7}
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&.Mui-focusVisible": {
                                    backgroundColor: "#f1f6fe !important",
                                  },
                                  ":hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                }}
                                onClick={(event: any) =>
                                  handleListItemClick(event, 7)
                                }>
                                <span>All</span>
                              </ListItemButton>
                            </MenuItem>
                            <Divider sx={{ margin: "0px !important" }} />
                            <MenuItem
                              sx={{ padding: "0px !important" }}
                              onClick={() => {
                                setIsCustomDate(true);
                                popupState.close(); // Close the menu
                              }}>
                              <ListItemButton
                                selected={selectedIndex === 6}
                                onClick={(event) =>
                                  handleListItemClick(event, 6)
                                }
                                sx={{
                                  "&.Mui-selected": {
                                    backgroundColor: "#25258f",
                                    color: "#ffffff",
                                  },
                                  "&:hover": { backgroundColor: "#f1f6fe" },
                                }}>
                                <span>Custom...</span>
                              </ListItemButton>
                            </MenuItem>
                          </>
                        )}
                      </StyledMenu>
                      <DateRangePopup
                        open={isCustomDate}
                        anchor={popupAnchor}
                        tempFromDate={tempFromDate}
                        tempToDate={tempToDate}
                        //minDate={dayjs(userContext.financialYearStartDate)}
                        //maxDate={dayjs(userContext.financialYearEndDate)}
                        error={dateError ?? undefined}
                        onFromChange={(value) => {
                          setTempFromDate(value);
                          if (
                            tempToDate &&
                            value &&
                            value.isAfter(tempToDate)
                          ) {
                            setDateError("From date cannot be after To date");
                          } else {
                            setDateError(null);
                          }
                        }}
                        onToChange={(value) => {
                          setTempToDate(value);
                          if (
                            tempFromDate &&
                            value &&
                            value.isBefore(tempFromDate)
                          ) {
                            setDateError("To date cannot be before From date");
                          } else {
                            setDateError(null);
                          }
                        }}
                        onApply={() => {
                          setIsCustomDate(false);
                          setDateRange([
                            {
                              startDate: tempFromDate?.toDate() ?? new Date(),
                              endDate: tempToDate?.toDate() ?? new Date(),
                              key: "selection",
                            },
                          ]);
                          setDateHeading(
                            `${tempFromDate?.format(
                              "DD-MM-YYYY"
                            )} to ${tempToDate?.format("DD-MM-YYYY")}`
                          );
                        }}
                        onCancel={() => {
                          setIsCustomDate(false);
                          setTempFromDate(null);
                          setTempToDate(null);
                          setDateError(null);
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        className="button-responsive-stock"
                        aria-controls={
                          openExportType ? "demo-customized-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={openExportType ? "true" : undefined}
                        disabled={resultData?.length <= 0}
                        variant="outlined"
                        disableElevation
                        onClick={handleClickExportType}
                        startIcon={<DownloadIcon />}
                        endIcon={<KeyboardArrowDownSharp />}>
                        Export
                      </Button>
                      <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                          "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorEl2}
                        open={openExportType}
                        onClose={handleCloseExportType}>
                        {/* <MenuItem
                          disableRipple
                          onClick={() => handelLabelLevelBalanceReportPopup("pdf")}>
                          PDF
                        </MenuItem> */}
                        <MenuItem
                          disableRipple
                          onClick={() => handelLabelLevelBalanceReportPopup("Excel")}>
                          EXCEL
                        </MenuItem>
                      </StyledMenu>
                    </Grid>
                    <Grid item>
                      <Tooltip title="Customize Columns" placement="top">
                        <IconButton
                          aria-label="Settings"
                          onClick={handleSettingsOpen}
                          sx={{ p: 0 }} disableRipple
                        >
                          <img src={CustomColumn} alt="Settings" height={20} />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        MenuListProps={{ disablePadding: true }}
                        onClose={handleSettingsClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuList sx={{ padding: 0 }}>
                          <Box
                            sx={{
                              border: "1px solid #c7c5c5",
                              borderRadius: "4px",
                              display: "flex",
                              flexDirection: "column",
                              overflow: "hidden",
                            }}
                          >
                            <Box
                              sx={{
                                backgroundColor: "#dee6fa",
                                color: "#404d54",
                                padding: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Settings
                            </Box>
                            <Box
                              sx={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {reportConfigData?.map(
                                (item, index) => (
                                  <MenuItem
                                    key={index}
                                    sx={{
                                      alignItems: "start",
                                      paddingLeft: "5px",
                                    }}
                                    onClick={(e) => {
                                      if (item?.isLocked) return;
                                      setReportConfigData((prev) =>
                                        prev.map((x) =>
                                          x.configKey ===
                                            item?.configKey
                                            ? {
                                              ...x,
                                              isChecked:
                                                !item?.isChecked,
                                            }
                                            : x
                                        )
                                      );
                                    }}
                                  >
                                    {item?.isLocked ? (
                                      <LockIcon />
                                    ) : (
                                      <Checkbox
                                        checked={item?.isChecked}
                                        sx={{
                                          padding: 0,
                                          margin: 0,
                                        }}
                                      />
                                    )}

                                    <Typography
                                      sx={{
                                        fontSize: "13px !important",
                                        fontWeight: "normal",
                                        paddingLeft: "8px",
                                      }}
                                    >
                                      {item?.configKeyLabel}
                                    </Typography>
                                  </MenuItem>
                                )
                              )}
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                borderTop: "1px solid #ccc",
                                px: 2,
                                py: 1,
                                gap: "5px",
                              }}
                            >
                              <Button
                                size="small"
                                onClick={() => {
                                  handleSettingsSave(reportConfigData);
                                  setAnchorEl(null);
                                }}
                                color="primary"
                                variant="contained"
                              >
                                Save
                              </Button>
                              <Button
                                onClick={handleSettingsClose}
                                size="small"
                              >
                                Close
                              </Button>
                            </Box>
                          </Box>
                        </MenuList>
                      </Menu>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

                  <TableContainer
                      sx={{
                          maxWidth: tableMaxWidth,
                          width: "100%",
                          overflowX: "auto",
                      }}
                  >
                    <Table 
                      aria-labelledby="tableTitle" 
                      size="medium"
                      sx={{
                          minWidth: "2000px",
                          '& .MuiTableCell-root': {
                              padding: '8px 12px',
                              whiteSpace: 'nowrap',
                          }
                      }}
                  >
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    rowCount={resultData?.length}
                    reportConfigDetail={reportConfigDetail}
                  />
                  {resultData?.length > 0 &&
                    (() => {
                      const totalPurchase = resultData.reduce(
                        (sum, item) => sum + (item?.materialPurchase || 0),
                        0
                      );
                      const totalOtherExpense = resultData.reduce(
                        (sum, item) => sum + (item?.otherExpense || 0),
                        0
                      );
                      const totalSubconExpense = resultData.reduce(
                        (sum, item) => sum + (item?.subconExpense || 0),
                        0
                      );
                      const totalSiteExpense = resultData.reduce(
                        (sum, item) => sum + (item?.siteExpense || 0),
                        0
                      );
                      const totalEquipmentExpense = resultData.reduce(
                        (sum, item) => sum + (item?.equipmentExpense || 0),
                        0
                      );
                      const totalCreditNote = resultData.reduce(
                        (sum, item) => sum + (item?.creditNote || 0),
                        0
                      );
                      const totalSalesInvoice = resultData.reduce(
                        (sum, item) => sum + (item?.salesInvoice || 0),
                        0
                      );
                      const totalMaterialSale = resultData.reduce(
                        (sum, item) => sum + (item?.materialSale || 0),
                        0
                      );
                      const totalDebitNote = resultData.reduce(
                        (sum, item) => sum + (item?.debitNote || 0),
                        0
                      );
                      const totalTotalPayment = resultData.reduce(
                        (sum, item) => sum + (item?.totalPayment || 0),
                        0
                      );
                      const totalPartyPaid = resultData.reduce(
                        (sum, item) => sum + (item?.partyPaid || 0),
                        0
                      );
                      // const totalAdvancePaid = resultData.reduce(
                      //   (sum, item) => sum + (item?.advancePaid || 0),
                      //   0
                      // );
                      const totalDuePayment = resultData.reduce(
                        (sum, item) => sum + (item?.duePayment || 0),
                        0
                      );
                      const totalTotalReceived = resultData.reduce(
                        (sum, item) => sum + (item?.totalReceived || 0),
                        0
                      );
                      const totalPartyReceived = resultData.reduce(
                        (sum, item) => sum + (item?.partyReceived || 0),
                        0
                      );
                      // const totalAdvanceReceived = resultData.reduce(
                      //   (sum, item) => sum + (item?.advanceReceived || 0),
                      //   0
                      // );
                      const totalDueReceived = resultData.reduce(
                        (sum, item) => sum + (item?.dueReceived || 0),
                        0
                      );
                      const totalNetBalance = resultData.reduce(
                        (sum, item) => sum + (item?.netBalance || 0),
                        0
                      );
                      const totalBalance = resultData.reduce(
                        (sum, item) => sum + (item?.balance || 0),
                        0
                      );

                      return (
                        <TableBody>
                          {stableSort(
                            resultData,
                            getComparator(order, orderBy)
                          ).map((item: any, index: any) => (
                            <TableRow key={index}>
                              <TableCell
                                sx={{
                                  display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                }}
                                align="left">
                                {item.partyName.toUpperCase()}
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                }}
                                align="left">
                                {item?.partyTable}
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                  borderRight: "1px solid #ccc",
                                }}
                                align="left">
                                {item?.projectName}
                              </TableCell>

                              {/* ===== EXPENSE GROUP - dynamic borderRight ===== */}
                              {reportConfig["MATERIAL_PURCHASE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: expenseLastKey === "MATERIAL_PURCHASE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.materialPurchase)}
                                </TableCell>
                              )}
                              {reportConfig["OTHER_EXPENSE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: expenseLastKey === "OTHER_EXPENSE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.otherExpense)}
                                </TableCell>
                              )}
                              {reportConfig["SUBCON_EXPENSE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: expenseLastKey === "SUBCON_EXPENSE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.subconExpense)}
                                </TableCell>
                              )}
                              {reportConfig["SITE_EXPENSE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: expenseLastKey === "SITE_EXPENSE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.siteExpense)}
                                </TableCell>
                              )}
                              {reportConfig["EQUIPMENT_EXPENSE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: expenseLastKey === "EQUIPMENT_EXPENSE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.equipmentExpense)}
                                </TableCell>
                              )}
                              {reportConfig["CREDIT_NOTE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: expenseLastKey === "CREDIT_NOTE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.creditNote)}
                                </TableCell>
                              )}

                              {/* ===== INCOME GROUP - dynamic borderRight ===== */}
                              {reportConfig["SALES_INVOICE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: incomeLastKey === "SALES_INVOICE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.salesInvoice)}
                                </TableCell>
                              )}
                              {reportConfig["MATERIAL_SALE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: incomeLastKey === "MATERIAL_SALE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.materialSale)}
                                </TableCell>
                              )}
                              {reportConfig["DEBIT_NOTE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: incomeLastKey === "DEBIT_NOTE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.debitNote)}
                                </TableCell>
                              )}

                              {/* ===== PAYMENT OUT GROUP - dynamic borderRight ===== */}
                              {reportConfig["TOTAL_PAYABLE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: paymentOutLastKey === "TOTAL_PAYABLE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.totalPayment)}
                                </TableCell>
                              )}
                              {reportConfig["PARTY_PAID"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: paymentOutLastKey === "PARTY_PAID" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.partyPaid)}
                                </TableCell>
                              )}
                              {reportConfig["DUE_PAYABLE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: paymentOutLastKey === "DUE_PAYABLE" ? "1px solid #ccc" : "none",
                                    fontWeight: "bold",
                                  }}
                                  align="right">
                                  {numberFormat(item?.duePayment)}
                                </TableCell>
                              )}

                              {/* ===== PAYMENT IN GROUP - dynamic borderRight ===== */}
                              {reportConfig["TOTAL_RECEIVABLE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: paymentInLastKey === "TOTAL_RECEIVABLE" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.totalReceived)}
                                </TableCell>
                              )}
                              {reportConfig["PARTY_RECEIVED"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: paymentInLastKey === "PARTY_RECEIVED" ? "1px solid #ccc" : "none",
                                  }}
                                  align="right">
                                  {numberFormat(item?.partyReceived)}
                                </TableCell>
                              )}
                              {reportConfig["DUE_RECEIVABLE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    borderRight: paymentInLastKey === "DUE_RECEIVABLE" ? "1px solid #ccc" : "none",
                                    fontWeight: "bold",
                                  }}
                                  align="right">
                                  {numberFormat(item?.dueReceived)}
                                </TableCell>
                              )}

                              {/* ===== BALANCE GROUP ===== */}
                              {reportConfig["NET_BALANCE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    fontWeight: "bold",
                                  }}
                                  align="right">
                                  {numberFormat(item?.netBalance)}
                                </TableCell>
                              )}
                              <TableCell
                                sx={{
                                  display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                }}
                                align="left">
                                {item?.balanceType}
                              </TableCell>
                              {reportConfig["HANDS_ON_BALANCE"] && (
                                <TableCell
                                  sx={{
                                    display: { xs: "table-cell", sm: "table-cell", md: "table-cell" },
                                    // borderRight: "1px solid #ccc",
                                    fontWeight: "bold",
                                  }}
                                  align="right">
                                  {numberFormat(item?.balance)}
                                </TableCell>
                              )}
                              <TableCell />
                            </TableRow>
                          ))}

                          {/* Total Row - Sticky at bottom */}
                          <TableRow 
                            sx={{ 
                              position: 'sticky',
                              bottom: 0,
                              backgroundColor: '#f5f5f5',
                              zIndex: 2,
                              '& .MuiTableCell-root': {
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                                borderBottom: 'none',
                              }
                            }}
                          >
                            <TableCell align="left" sx={{ fontWeight: "bold" }}>
                              Total
                            </TableCell>
                            <TableCell />
                            <TableCell
                              sx={{ borderRight: "1px solid #ccc" }}>
                            </TableCell>

                            {/* ===== EXPENSE GROUP TOTALS - dynamic borderRight ===== */}
                            {reportConfig["MATERIAL_PURCHASE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: expenseLastKey === "MATERIAL_PURCHASE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalPurchase)}
                              </TableCell>
                            )}
                            {reportConfig["OTHER_EXPENSE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: expenseLastKey === "OTHER_EXPENSE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalOtherExpense)}
                              </TableCell>
                            )}
                            {reportConfig["SUBCON_EXPENSE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: expenseLastKey === "SUBCON_EXPENSE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalSubconExpense)}
                              </TableCell>
                            )}
                            {reportConfig["SITE_EXPENSE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: expenseLastKey === "SITE_EXPENSE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalSiteExpense)}
                              </TableCell>
                            )}
                            {reportConfig["EQUIPMENT_EXPENSE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: expenseLastKey === "EQUIPMENT_EXPENSE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalEquipmentExpense)}
                              </TableCell>
                            )}
                            {reportConfig["CREDIT_NOTE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: expenseLastKey === "CREDIT_NOTE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalCreditNote)}
                              </TableCell>
                            )}

                            {/* ===== INCOME GROUP TOTALS - dynamic borderRight ===== */}
                            {reportConfig["SALES_INVOICE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: incomeLastKey === "SALES_INVOICE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalSalesInvoice)}
                              </TableCell>
                            )}
                            {reportConfig["MATERIAL_SALE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: incomeLastKey === "MATERIAL_SALE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalMaterialSale)}
                              </TableCell>
                            )}
                            {reportConfig["DEBIT_NOTE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: incomeLastKey === "DEBIT_NOTE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalDebitNote)}
                              </TableCell>
                            )}

                            {/* ===== PAYMENT OUT GROUP TOTALS - dynamic borderRight ===== */}
                            {reportConfig["TOTAL_PAYABLE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: paymentOutLastKey === "TOTAL_PAYABLE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalTotalPayment)}
                              </TableCell>
                            )}
                            {reportConfig["PARTY_PAID"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: paymentOutLastKey === "PARTY_PAID" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalPartyPaid)}
                              </TableCell>
                            )}
                            {reportConfig["DUE_PAYABLE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: paymentOutLastKey === "DUE_PAYABLE" ? "1px solid #ccc" : "none",
                                }}
                              >
                                <span style={{ color: "red" }}>
                                  {numberFormat(totalDuePayment)}
                                </span>
                              </TableCell>
                            )}

                            {/* ===== PAYMENT IN GROUP TOTALS - dynamic borderRight ===== */}
                            {reportConfig["TOTAL_RECEIVABLE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: paymentInLastKey === "TOTAL_RECEIVABLE" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalTotalReceived)}
                              </TableCell>
                            )}
                            {reportConfig["PARTY_RECEIVED"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: paymentInLastKey === "PARTY_RECEIVED" ? "1px solid #ccc" : "none",
                                }}>
                                {numberFormat(totalPartyReceived)}
                              </TableCell>
                            )}
                            {reportConfig["DUE_RECEIVABLE"] && (
                              <TableCell
                                align="right"
                                sx={{
                                  fontWeight: "bold",
                                  borderRight: paymentInLastKey === "DUE_RECEIVABLE" ? "1px solid #ccc" : "none",
                                }}>
                                <span style={{ color: "green" }}>
                                  {numberFormat(totalDueReceived)}
                                </span>
                              </TableCell>
                            )}

                            {/* ===== BALANCE GROUP TOTALS ===== */}
                            <TableCell />
                            <TableCell
                            />
                            {reportConfig["HANDS_ON_BALANCE"] && (
                              <TableCell
                                align="right"
                                sx={{ fontWeight: "bold" }}>
                                <span style={{ color: "green" }}>
                                  {numberFormat(totalBalance)}
                                </span>
                              </TableCell>
                            )}
                            <TableCell />
                          </TableRow>
                        </TableBody>
                      );
                    })()}

                  {(!resultData || resultData.length <= 0) && (
                    <TableBody>
                      <TableRow hover tabIndex={-1} key={"0"}>
                        <TableCell colSpan={7} align="center">
                          No record(s) found
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>

              {/* Pagination - Fixed outside scroll container */}
              {resultData?.length > 0 && (
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderTop: '1px solid #e0e0e0',
                    padding: '8px 0',
                    width: '100%',
                  }}
                >
                  <Grid
                    container
                    paddingTop={1}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Grid item xs={12} sm={6} className="pagination-label">
                      {pageInfo.startIndex} - {pageInfo.endIndex} of {totalCount}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack
                        component="div"
                        alignItems={mobileScreen ? "center" : "end"}
                        justifyContent={"center"}
                      >
                        <Pagination
                          color="primary"
                          count={pageInfo.totalPages}
                          page={page}
                          onChange={handlePageChange}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Paper>
          </Grid>
        </Box>
      ) : (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          <MissingConsumer consumerId={userContext.consumerId} />
        </Box>
      )}
    </>
  );
}
